export class StickyMediator
{
    private toolbox: HTMLElement;
    private thead: HTMLTableSectionElement;

    onToolbox = (div: HTMLElement) => {
        this.toolbox = div;
        this.stickyfiy();
    }

    onThead = (thead: HTMLTableSectionElement) => {
        this.thead = thead;
        this.stickyfiy();        
    }

    stickyfiy = () => {
        if(!this.toolbox || !this.thead)
            return;

        const { clientHeight } = this.toolbox;
        const style = getComputedStyle(this.toolbox);
        const dy = clientHeight + parseInt(style.marginTop, 10) + parseInt(style.marginBottom, 10);
        const trs = this.thead.children;
        for(let i=0; i < trs.length; i++) {
            const tr = trs[i];
            if(tr.nodeName !== 'TR') continue;
            const ths = tr.children;
            for(let j=0; j<ths.length; j++) {
                const th = ths[j];
                if(th.nodeName !== 'TH') continue;
                (th as HTMLTableHeaderCellElement).style.top = `${dy}px`;
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/utils/StickyMediator.ts